import {useQuery} from "@tanstack/react-query";
import * as _a from "@/lib/api";

export const useChannels = () => {
  return useQuery({
    queryKey: ['channels'],
    queryFn: () => _a.channels()
  });
}